<!--eslint-disable-->
<template>
    <div>
        <el-table
            :data="tableData"
            border
            :cell-class-name="tableRowClassName"
            style="width: 1279px">
            <el-table-column
                prop="pnl"
                label="P&L"
                :render-header="renderHeader"
                width="348">
            </el-table-column>
            <el-table-column
                prop="total"
                label="TOTAL"
                :formatter="numberFormatter"
                :render-header="renderHeader"
                align="right"
                width="186">
                <template slot-scope="scope">
                    <NewEditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot" v-on:numberFormatter="numberFormatter"></NewEditableColumn>
                    <NewFixedColumn v-else :scope="scope" v-on:numberFormatter="numberFormatter"></NewFixedColumn>
                </template>
            </el-table-column>
            <el-table-column
                prop="publicEquitiesRF"
                label="Public Equities"
                :formatter="numberFormatter"
                :render-header="renderHeaderRF"
                align="right"
                width="186">
                <template slot-scope="scope">
                    <NewEditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot" v-on:numberFormatter="numberFormatter"></NewEditableColumn>
                    <NewFixedColumn v-else :scope="scope" v-on:numberFormatter="numberFormatter"></NewFixedColumn>
                </template>
            </el-table-column>
            <el-table-column
                prop="publicEquitiesRV"
                label="Public Equities"
                :formatter="numberFormatter"
                :render-header="renderHeaderRV"
                align="right"
                width="186">
                <template slot-scope="scope">
                    <NewEditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot" v-on:numberFormatter="numberFormatter"></NewEditableColumn>
                    <NewFixedColumn v-else :scope="scope" v-on:numberFormatter="numberFormatter"></NewFixedColumn>
                </template>
            </el-table-column>
            <el-table-column
                prop="previdencia"
                label="Previdência"
                :formatter="numberFormatter"
                :render-header="renderHeader"
                align="right"
                width="186">
                <template slot-scope="scope">
                    <NewEditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot" v-on:numberFormatter="numberFormatter"></NewEditableColumn>
                    <NewFixedColumn v-else :scope="scope" v-on:numberFormatter="numberFormatter"></NewFixedColumn>
                </template>
            </el-table-column>
            <el-table-column
                prop="privateEquities"
                label="Private Equities & PIPEs"
                :render-header="renderHeader"
                align="right"
                :formatter="numberFormatter"
                width="186">
                <template slot-scope="scope">
                    <NewEditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot" v-on:numberFormatter="numberFormatter"></NewEditableColumn>
                    <NewFixedColumn v-else :scope="scope" v-on:numberFormatter="numberFormatter"></NewFixedColumn>
                </template>
            </el-table-column>
        </el-table>
        
    </div>
    
</template>

<script>
/*eslint-disable*/
import fb from '@/services/firebaseConfig'
import formatters from '@/services/formatters';
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import NewFixedColumn from '@/components/NewFixedColumn.vue'
import firebase from 'firebase/app'

const db = fb.db

export default {
    data() {
        return {
            snapshot: [],
            editing: null,
            refDate: null,
            costs: {
                people: null,
                rent: null,
                others: null,
                taxes_perc: null 
            }
            
        }
    },
    components: {
        NewEditableColumn,
        NewFixedColumn
    },
    methods: {
        numberFormatterCurrency(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'currency',0)
        },
        numberFormatterPercent(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'percent', 0)
        },
        numberFormatterDecimal(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'decimal', 1)
        },
        numberFormatterPercent1(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'percent', 2)
        },
        numberFormatter(cellValue, index) {
            
            // percentCells: sem casas decimais
            var percentCells = [1, 6, 7, 19]
            
            //smallPercentCells: 1 casa decimal
            var smallPercentCells = [3, 5, 9, 11, 14, 16, 18, 25]
            
            //miniPercentCell: 2 casas decimais
            var miniPercentCells = [12]
            
            var currencyCells = [0, 2, 4, 8, 10, 13, 15, 17, 21, 22, 23, 24]
            if(percentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 0)
            }
            if(smallPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 1)
            }
            if(miniPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 2)
            }
            if(currencyCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'currency',0)
            }
            
        },
        renderHeaderRF(h, { column }) {
            return [
                h('p', { 'class': 'header-title'  }, column.label),
                h('p', { 'class': 'header-details' }, 'benchmark RF')
            ]
        },
        renderHeaderRV(h, { column }) {
            return [
                h('p', { 'class': 'header-title'  }, column.label),
                h('p', { 'class': 'header-details' }, 'benchmark RV')
            ]
        },
        renderHeader(h, { column }) {
            return [
                h('p', { 'class': 'header-title' }, column.label),
                h('p', { 'class': 'header-details' }, '')
            ]
        },
        tableRowClassName({row, column, rowIndex, columnIndex}) {
            var detailsIndexes = [1, 3, 5, 6, 7, 9, 11, 12, 14, 16, 18, 19, 21, 22, 23, 25]
            var receitaLiquidaIndexes = [17, 18, 19]
            var aumIndexes = [0, 1]
            var lucroIndexes = [24, 25]
            var rebateIndexes = [6, 8]
            var classes = ' cell-size'
            
            if(detailsIndexes.includes(rowIndex)) {
                classes += ' details-row';
            }
            if(aumIndexes.includes(rowIndex)) {
                classes += ' aum-row';
            }
            if(receitaLiquidaIndexes.includes(rowIndex)) {
                classes += ' rec-liq-row';
            }
            if(lucroIndexes.includes(rowIndex)) {
                classes += ' lucro-row';
            }
            if(rebateIndexes.includes(rowIndex)) {
                classes += ' rebate-row'
            }
            return classes;
        },
        isEditable(index, row, column) {
            if(index == 16 && column.property != "total") return true
            if((index == 23 || index == 22 || index == 21) && column.property == "total") return true
            if(index == 7 && column.property == "previdencia") return true
            return false
        },
        async saveSnapshot(value, scope) {
            
            if(scope.$index == 7) {
                this.snapshot.filter(snap => snap.type_name == "prev")[0].avgRebate = Number(value)
                
                var savePrevAvgRebate = firebase.functions().httpsCallable('savePrevAvgRebate')
                try {
                    var result = await savePrevAvgRebate({avgRebate: Number(value)})
                } catch (err) {
                    this.$alert(err)
                }
            }
            
            if(scope.$index == 21 || scope.$index == 22 || scope.$index == 23 || scope.$index == 16) {
                
                let companyCostsMap = {
                    '% Receita Bruta': 'taxes_perc',
                    'Pessoal': 'people',
                    'Ocupação': 'rent',
                    'Outros': 'others'
                }
                
                let category = companyCostsMap[scope.row.pnl]
                this.costs[category] = Number(value)
                
                var saveCompanyCosts = firebase.functions().httpsCallable('saveCompanyCosts')
                try {
                    var result = await saveCompanyCosts({category: category, value: Number(value)})
                } catch (err) {
                    this.$alert(err)
                }
            }
            
            let costs = {
                people: this.costs.people,
                rent: this.costs.rent,
                others: this.costs.others,
                taxes_perc: this.costs.taxes_perc
            }
            
            var saveUserChangesInFinReport = firebase.functions().httpsCallable('saveUserChangesInFinReport')
            try {
                var result = await saveUserChangesInFinReport({refDate: this.refDate, snapshot: this.snapshot, costs: costs})
            } catch (err) {
                this.$alert(err)
            }
        },
    },
    computed: {
        tableData() {
            
            if(this.snapshot === undefined || this.snapshot.length == 0 || this.refDate === undefined) return
            
            // Total AUM
            let totalAum = 0
            this.snapshot.forEach(snap => {
                totalAum += snap.aum
            })
            
            // Linha 0: AUM
            let totalAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].aum
            let totalAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].aum
            let totalAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].aum
            let totalAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].aum
            
            // Linha 1: % Total
            let totalPercPublicRf = totalAumPublicRf/totalAum;
            let totalPercPublicRv = totalAumPublicRv/totalAum;
            let totalPercPrev = totalAumPrev/totalAum;
            let totalPercPe = totalAumPe/totalAum;
            
            // Linha 3: % AUM
            let receitaBrutaAdmPercAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgTxAdm
            let receitaBrutaAdmPercAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgTxAdm;
            let receitaBrutaAdmPercAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgTxAdm;
            let receitaBrutaAdmPercAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgTxAdm;
            
            // Linha 2: (+) Receita Bruta ADM
            let receitaBrutaAdmPublicRf = totalAumPublicRf * receitaBrutaAdmPercAumPublicRf;
            let receitaBrutaAdmPublicRv = totalAumPublicRv * receitaBrutaAdmPercAumPublicRv;
            let receitaBrutaAdmPrev = totalAumPrev * receitaBrutaAdmPercAumPrev;
            let receitaBrutaAdmPe = totalAumPe * receitaBrutaAdmPercAumPe;
            
            let receitaBrutaAdmTotal = receitaBrutaAdmPe + receitaBrutaAdmPrev + receitaBrutaAdmPublicRf + receitaBrutaAdmPublicRv;
            let receitaBrutaAdmPercTotal = receitaBrutaAdmTotal/totalAum;
            
            // Linha 6: % Distribuidores
            let distribuidoresPercPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].aumDist/totalAumPublicRf
            let distribuidoresPercPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].aumDist/totalAumPublicRv
            let distribuidoresPercPrev = 1
            let distribuidoresPercPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].aumDist/totalAumPe
            
            // Linha 7: Rebate Médio
            let rebateMedioPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgRebate
            let rebateMedioPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgRebate
            let rebateMedioPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgRebate
            let rebateMedioPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgRebate
            
            // Linha 4: (-) REBATES
            let rebatePublicRf = -receitaBrutaAdmPublicRf * distribuidoresPercPublicRf * rebateMedioPublicRf
            let rebatePublicRv = -receitaBrutaAdmPublicRv * distribuidoresPercPublicRv * rebateMedioPublicRv
            let rebatePrev = -receitaBrutaAdmPrev * distribuidoresPercPrev * rebateMedioPrev
            let rebatePe = -receitaBrutaAdmPe * distribuidoresPercPe * rebateMedioPe
        
            let totalRebate = rebatePublicRf + rebatePublicRv + rebatePrev + rebatePe
            
            // Linha 5: % Receita Bruta ADM
            let receitaBrutaPercPublicRf = distribuidoresPercPublicRf * rebateMedioPublicRf
            let receitaBrutaPercPublicRv = distribuidoresPercPublicRv * rebateMedioPublicRv
            let receitaBrutaPercPrev = distribuidoresPercPrev * rebateMedioPrev
            let receitaBrutaPercPe = distribuidoresPercPe * rebateMedioPe
            
            // Linha 8: (=) Receita Bruta ADM pós rebates
            let receitaBrutaPosRebatesPublicRf = receitaBrutaAdmPublicRf + rebatePublicRf
            let receitaBrutaPosRebatesPublicRv = receitaBrutaAdmPublicRv + rebatePublicRv
            let receitaBrutaPosRebatesPrev = receitaBrutaAdmPrev + rebatePrev
            let receitaBrutaPosRebatesPe = receitaBrutaAdmPe + rebatePe
            let receitaBrutaPosRebatesTotal = receitaBrutaPosRebatesPublicRf + receitaBrutaPosRebatesPublicRv + receitaBrutaPosRebatesPrev + receitaBrutaPosRebatesPe
            
            // Linha 9: % AUM
            let receitaBrutaPosRebatesPercAumPublicRf = receitaBrutaPosRebatesPublicRf/totalAumPublicRf
            let receitaBrutaPosRebatesPercAumPublicRv = receitaBrutaPosRebatesPublicRv/totalAumPublicRv
            let receitaBrutaPosRebatesPercAumPrev = receitaBrutaPosRebatesPrev/totalAumPrev
            let receitaBrutaPosRebatesPercAumPe = receitaBrutaPosRebatesPe/totalAumPe
            let receitaBrutaPosRebatesPercAumTotal = receitaBrutaPosRebatesTotal/totalAum
            
            // Linha 12: % AUM
            let administradoresPercAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgTxAdministrator
            let administradoresPercAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgTxAdministrator
            let administradoresPercAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgTxAdministrator
            let administradoresPercAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgTxAdministrator
                
            // Linha 10: (-) ADMINISTRADORES
            let administradoresPublicRf = -administradoresPercAumPublicRf * totalAumPublicRf
            let administradoresPublicRv = -administradoresPercAumPublicRv * totalAumPublicRv
            let administradoresPrev = -administradoresPercAumPrev * totalAumPrev
            let administradoresPe = -administradoresPercAumPe * totalAumPe
            let administradoresTotal = administradoresPe + administradoresPrev + administradoresPublicRf + administradoresPublicRv
            let administradoresPercAumTotal = -administradoresTotal/totalAum
            
            // LInha 11: % Receita Bruta ADM pós rebates
            let receitaBrutaPercPosRebatesPublicRf = administradoresPublicRf/receitaBrutaPosRebatesPublicRf
            let receitaBrutaPercPosRebatesPublicRv = administradoresPublicRv/receitaBrutaPosRebatesPublicRv
            let receitaBrutaPercPosRebatesPrev = administradoresPrev/receitaBrutaPosRebatesPrev
            let receitaBrutaPercPosRebatesPe = administradoresPe/receitaBrutaPosRebatesPe
            let receitaBrutaPercPosRebatesTotal = administradoresTotal/receitaBrutaPosRebatesTotal
            
            // Linha 13: (=) Receita Bruta
            let receitaBrutaPublicRf = receitaBrutaPosRebatesPublicRf + administradoresPublicRf
            let receitaBrutaPublicRv = receitaBrutaPosRebatesPublicRv + administradoresPublicRv
            let receitaBrutaPrev = receitaBrutaPosRebatesPrev + administradoresPrev
            let receitaBrutaPe = receitaBrutaPosRebatesPe + administradoresPe
            let receitaBrutaTotal = receitaBrutaPublicRf + receitaBrutaPublicRv + receitaBrutaPrev + receitaBrutaPe
            
            // Linha 14: % AUM
            let receitaBrutaPercAumPublicRf = receitaBrutaPublicRf/totalAumPublicRf
            let receitaBrutaPercAumPublicRv = receitaBrutaPublicRv/totalAumPublicRv
            let receitaBrutaPercAumPrev = receitaBrutaPrev/totalAumPrev
            let receitaBrutaPercAumPe = receitaBrutaPe/totalAumPe
            let receitaBrutaPercAumTotal = receitaBrutaTotal/totalAum
            
            // Linha 16: % Receita Bruta
            let impostosPercPublicRf = this.costs.taxes_perc
            let impostosPercPublicRv = this.costs.taxes_perc
            let impostosPercPrev = this.costs.taxes_perc
            let impostosPercPe = this.costs.taxes_perc
            
            // Linha 15: (-) IMPOSTOS
            let impostosPublicRf = receitaBrutaPublicRf * impostosPercPublicRf
            let impostosPublicRv = receitaBrutaPublicRv * impostosPercPublicRv
            let impostosPrev = receitaBrutaPrev * impostosPercPrev
            let impostosPe = receitaBrutaPe * impostosPercPe
            let impostosTotal = impostosPublicRf + impostosPublicRv + impostosPrev + impostosPe
            let impostosPercTotal = impostosTotal/receitaBrutaTotal
            
            // Linha 17: Receita Liquida
            let receitaLiquidaPublicRf = receitaBrutaPublicRf - impostosPublicRf
            let receitaLiquidaPublicRv = receitaBrutaPublicRv - impostosPublicRv
            let receitaLiquidaPrev = receitaBrutaPrev - impostosPrev
            let receitaLiquidaPe = receitaBrutaPe - impostosPe
            let receitaLiquidaTotal = receitaLiquidaPublicRf + receitaLiquidaPublicRv + receitaLiquidaPrev + receitaLiquidaPe
            
            // Linha 18: % AUM
            let receitaLiquidaPercAumPublicRf = receitaLiquidaPublicRf/totalAumPublicRf
            let receitaLiquidaPercAumPublicRv = receitaLiquidaPublicRv/totalAumPublicRv
            let receitaLiquidaPercAumPrev = receitaLiquidaPrev/totalAumPrev
            let receitaLiquidaPercAumPe = receitaLiquidaPe/totalAumPe
            let receitaLiquidaPercAumTotal = receitaLiquidaTotal/totalAum
            
            // Linha 19: % Total
            let receitaLiquidaPercTotalPublicRf = receitaLiquidaPublicRf/receitaLiquidaTotal
            let receitaLiquidaPercTotalPublicRv = receitaLiquidaPublicRv/receitaLiquidaTotal
            let receitaLiquidaPercTotalPrev = receitaLiquidaPrev/receitaLiquidaTotal
            let receitaLiquidaPercTotalPe = receitaLiquidaPe/receitaLiquidaTotal
            
            
            let despesasPessoa = this.costs.people
            let despesasOcupacao = this.costs.rent
            let despesasOutros = this.costs.others
            
            let lucroLiquido = receitaLiquidaTotal - despesasPessoa - despesasOcupacao - despesasOutros
            let lucroLiquidoPercAum = lucroLiquido/totalAum
            
            let aux = [
                {pnl:'AUM', total: totalAum, publicEquitiesRF: totalAumPublicRf, publicEquitiesRV: totalAumPublicRv, previdencia: totalAumPrev, privateEquities: totalAumPe},
                {pnl:'% TOTAL' , total: 0, publicEquitiesRF: totalPercPublicRf, publicEquitiesRV: totalPercPublicRf, previdencia: totalPercPrev, privateEquities: totalPercPe},
                {pnl:'(+) Receita Bruta ADM' , total: receitaBrutaAdmTotal, publicEquitiesRF: receitaBrutaAdmPublicRf, publicEquitiesRV: receitaBrutaAdmPublicRv, previdencia: receitaBrutaAdmPrev, privateEquities: receitaBrutaAdmPe},
                {pnl:'% AUM' , total: receitaBrutaAdmPercTotal, publicEquitiesRF: receitaBrutaAdmPercAumPublicRf, publicEquitiesRV: receitaBrutaAdmPercAumPublicRv, previdencia: receitaBrutaAdmPercAumPrev, privateEquities: receitaBrutaAdmPercAumPe},
                {pnl:'(-) REBATES' , total: totalRebate, publicEquitiesRF: rebatePublicRf, publicEquitiesRV: rebatePublicRv, previdencia: rebatePrev, privateEquities: rebatePe},
                {pnl:'% Receita Bruta ADM' , total: 0, publicEquitiesRF: receitaBrutaPercPublicRf, publicEquitiesRV: receitaBrutaPercPublicRv, previdencia: receitaBrutaPercPrev, privateEquities: receitaBrutaPercPe},
                {pnl:'% Distribuidores' , total: 0, publicEquitiesRF: distribuidoresPercPublicRf, publicEquitiesRV: distribuidoresPercPublicRv, previdencia: distribuidoresPercPrev, privateEquities: distribuidoresPercPe},
                {pnl:'Rebate Médio',  total: 0, publicEquitiesRF: rebateMedioPublicRf, publicEquitiesRV: rebateMedioPublicRv, previdencia: rebateMedioPrev, privateEquities: rebateMedioPe},
                {pnl:'(=) Receita Bruta ADM pós rebates' , total: receitaBrutaPosRebatesTotal, publicEquitiesRF: receitaBrutaPosRebatesPublicRf, publicEquitiesRV: receitaBrutaPosRebatesPublicRv, previdencia: receitaBrutaPosRebatesPrev, privateEquities: receitaBrutaPosRebatesPe},
                {pnl:'% AUM' , total: receitaBrutaPosRebatesPercAumTotal, publicEquitiesRF: receitaBrutaPosRebatesPercAumPublicRf, publicEquitiesRV: receitaBrutaPosRebatesPercAumPublicRv, previdencia: receitaBrutaPosRebatesPercAumPrev, privateEquities: receitaBrutaPosRebatesPercAumPe},
                {pnl:'(-) ADMINISTRADORES' , total: administradoresTotal, publicEquitiesRF: administradoresPublicRf, publicEquitiesRV: administradoresPublicRv, previdencia: administradoresPrev, privateEquities: administradoresPe},
                {pnl:'% Receita Bruta ADM pós rebates' , total: receitaBrutaPercPosRebatesTotal, publicEquitiesRF: receitaBrutaPercPosRebatesPublicRf, publicEquitiesRV: receitaBrutaPercPosRebatesPublicRv, previdencia: receitaBrutaPercPosRebatesPrev, privateEquities: receitaBrutaPercPosRebatesPe},
                {pnl:'% AUM' , total: administradoresPercAumTotal, publicEquitiesRF: administradoresPercAumPublicRf, publicEquitiesRV: administradoresPercAumPublicRv, previdencia: administradoresPercAumPrev, privateEquities: administradoresPercAumPe},
                {pnl:'(=) Receita Bruta' , total: receitaBrutaTotal, publicEquitiesRF: receitaBrutaPublicRf, publicEquitiesRV: receitaBrutaPublicRv, previdencia: receitaBrutaPrev, privateEquities: receitaBrutaPe},
                {pnl:'% AUM' , total: receitaBrutaPercAumTotal, publicEquitiesRF: receitaBrutaPercAumPublicRf, publicEquitiesRV: receitaBrutaPercAumPublicRv, previdencia: receitaBrutaPercAumPrev, privateEquities: receitaBrutaPercAumPe},
                {pnl:'(-) IMPOSTOS' , total: impostosTotal, publicEquitiesRF: impostosPublicRf, publicEquitiesRV: impostosPublicRv, previdencia: impostosPrev, privateEquities: impostosPe},
                {pnl:'% Receita Bruta' , total: impostosPercTotal, publicEquitiesRF: impostosPercPublicRf, publicEquitiesRV: impostosPercPublicRv, previdencia: impostosPercPrev, privateEquities: impostosPercPe},
                {pnl:'Receita Líquida' , total: receitaLiquidaTotal, publicEquitiesRF: receitaLiquidaPublicRf, publicEquitiesRV: receitaLiquidaPublicRv, previdencia: receitaLiquidaPrev, privateEquities: receitaLiquidaPe},
                {pnl:'% AUM' , total: receitaLiquidaPercAumTotal, publicEquitiesRF: receitaLiquidaPercAumPublicRf, publicEquitiesRV: receitaLiquidaPercAumPublicRv, previdencia: receitaLiquidaPercAumPrev, privateEquities: receitaLiquidaPercAumPe},
                {pnl:'% Total' , total: 0, publicEquitiesRF: receitaLiquidaPercTotalPublicRf, publicEquitiesRV: receitaLiquidaPercTotalPublicRv, previdencia: receitaLiquidaPercTotalPrev, privateEquities: receitaLiquidaPercTotalPe},
                {pnl:'(-) Despesas' , total: 0, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0},
                {pnl:'Pessoal' , total: despesasPessoa, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0},
                {pnl:'Ocupação' , total: despesasOcupacao, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0},
                {pnl:'Outros' , total: despesasOutros, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0},
                {pnl:'(=) Lucro Líquido' , total: lucroLiquido, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0},
                {pnl:'% AUM' , total: lucroLiquidoPercAum, publicEquitiesRF: 0, publicEquitiesRV:0 , previdencia: 0, privateEquities: 0}
            ]
            
            return aux
        },
    },
    created() {
        
        db.collection('finReportSnapshot')
            .orderBy('_refDate', 'desc')
            .orderBy('_lastUpdate', 'desc')
            .limit(1)
            .onSnapshot(
                q => {
                    let people, rent, others, taxes_perc
                    let _refDate;
                    let snap;
                    
                    q.forEach(doc => {
                        _refDate = doc.data()._refDate
                        snap = doc.data().snapshot
                        people = doc.data().people
                        rent = doc.data().rent
                        others = doc.data().others
                        taxes_perc = doc.data().taxes_perc
                    })
                    this.snapshot = snap
                    this.refDate = _refDate
                    this.costs = {
                        people: people,
                        rent: rent,
                        others: others,
                        taxes_perc: taxes_perc
                    }
            })
        
    },
    updated() {
        
    }
}
</script>

<style>
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
}
.header-details {
    margin:0;
    font-size:11px;
    font-style:italic;
}
.el-table .details-row {
    font-size:12px;
    font-style:italic;
    text-align: right;
}
.el-table .aum-row {
    font-weight:bold;
    background:#f2f2f2;
}
.el-table .lucro-row {
    font-weight:bold;
    background: #ebf1de;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-table .rec-liq-row {
    font-weight:bold;
}
.el-table .rebate-row {
    border-top: 1px solid;
}
</style>